import { useEffect, useState } from "react";
import { AnalyticsMetadata } from "../../../../../../models/analysis/Config";
import { ImportWizardPagePropsBase } from "../../ImportWizard";
import ImportMetadataGroup from "./components/ImportMetadataGroup";

export interface MetadataEntryPageProps extends ImportWizardPagePropsBase {
    value: ImportMetadataResults | undefined;
    analyserMetadata: AnalyticsMetadata;
}

export interface ImportMetadataResults {
    [groupKey: string]: { [entryKey: string]: string };
}

function MetadataEntryPage(props: MetadataEntryPageProps) {
    const onChanged = (data: unknown) => {
        props.dataChanged(data);
    };

    const groups = props.analyserMetadata?.groups ?? [];

    const [results, setResults] = useState<ImportMetadataResults>(
        () =>
            props.value ??
            groups.reduce((acc_g, g) => {
                acc_g[g.name] = g.entries.reduce((acc_e, e) => {
                    acc_e[e.name] = "";
                    return acc_e;
                }, {});
                return acc_g;
            }, {}),
    );

    const [groupValidities, setGroupValidities] = useState<boolean[]>(() => groups.map((_) => false));

    const handleGroupValidityChanged = (index: number, isValid: boolean) => {
        setGroupValidities((oldValidities) => {
            const newValidities = [...oldValidities];
            newValidities[index] = isValid;

            return newValidities;
        });
    };

    const isValid = groupValidities.length ? groupValidities.reduce((acc, curr) => acc && curr, true) : false;

    useEffect(() => {
        props.validityChanged(isValid);
    }, [isValid]);

    useEffect(() => {
        if (results === undefined || Object.keys(results).length === 0) {
            return;
        }

        onChanged(results);
    }, [results]);

    return (
        <div>
            {groups.map((group, i) => (
                <ImportMetadataGroup
                    key={group.name}
                    group={group}
                    results={results}
                    setResults={setResults}
                    showValidationWarnings={true}
                    onValidityChanged={(isValid) => handleGroupValidityChanged(i, isValid)}
                />
            ))}
        </div>
    );
}

export default MetadataEntryPage;
